import { render, staticRenderFns } from "./_taskDetailsStep.vue?vue&type=template&id=0541acc2"
import script from "./_taskDetailsStep.vue?vue&type=script&lang=js"
export * from "./_taskDetailsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports